import { Socket } from 'ngx-socket-io';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom, Observable, Subscription } from 'rxjs';

import { OfflineDetectionService } from '@app/services/offline-detection.service';
import { ToastService } from '@app/services/toast.service';
import { UserService } from '@app/services/user.service';
import { Events } from '@app/services/events.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private offlineDetectionSrv = inject(OfflineDetectionService);
  private toastSrv = inject(ToastService);
  private userSrv = inject(UserService);
  private socket = inject(Socket);
  private events = inject(Events);

  subscription?: Subscription;

  constructor() {
    this.onConnect();
    this.onConnectError();
  }

  onConnect() {
    this.socket.on<'connect'>('connect', () => {
      this.offlineDetectionSrv.setOfflineMode(false);
      if (this.userSrv.isLoggedIn()) {
        this.events.publish('socket:login');
      }
      this.subscription = this.userSrv.user$.subscribe((user) => this.sendMessage('setUser', user));
    });
  }

  onConnectError() {
    this.socket.on('connect_error', async () => {
      if (this.userSrv.isLoggedIn() && !(await firstValueFrom(this.offlineDetectionSrv.isOfflineMode()))) {
        await this.toastSrv.showToast('Cannot connect to the server, set Offline Mode...');
        this.offlineDetectionSrv.setOfflineMode(true);
      }
      this.subscription?.unsubscribe();
    });
  }

  sendMessage<T>(event: string, msg: T) {
    this.socket.emit(event, msg);
  }

  getMessage<T = string>(event: string): Observable<T> {
    return this.socket.fromEvent(event);
  }
}
